import { ChangeEvent, ChangeEventHandler } from 'react';
import { getUuidV4 } from '~/utils';
import { ThemeColorKeys } from '~/styles/themes';
import { Icon } from '../index';
import * as S from './Checkbox.styled';

export type ColorType = Extract<ThemeColorKeys, 'brand' | 'basic'> | 'blue';

export interface CheckboxProps {
  colorType?: ColorType;
  id?: string;
  checked: boolean;
  onIdClick?: (id: string) => void;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  label?: string | React.ReactNode;
  disabled?: boolean;
}

export default function Checkbox({
  colorType = 'brand',
  id: idProp,
  checked,
  onIdClick,
  onChange,
  label,
  disabled,
}: CheckboxProps) {
  const id = idProp ?? getUuidV4();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    onIdClick && onIdClick(id);
  };

  return (
    <>
      {!disabled && (
        <S.Container colorType={colorType}>
          <input
            type='checkbox'
            checked={checked}
            id={id}
            onChange={handleChange}
          />
          <S.CheckWrap htmlFor={id} colorType={colorType}>
            <S.CheckIcon colorType={colorType}>
              <Icon iconName='Check' size={18} />
            </S.CheckIcon>
            {label && <S.Label>{label}</S.Label>}
          </S.CheckWrap>
        </S.Container>
      )}
    </>
  );
}
